import React, { Component } from "react";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import SimpleDataTable from "../../../../modules/SimpleDataTable";
import { INITIAL_VALUE_TABLE_DETAIL, tableConfigDetailPage } from "../config";
import MasterHargaJasaDetailHeader from "./masterHargaJasaDetailHeader";
import MasterHargaJasaUpload from "./masterHargaJasaUpload";
import FlexView from "react-flexview";
import { fetchDataAsync } from "../../../../Services/Utils";
import Api from "../../../../Services/Api";
import {
  ACTIVITY_TYPE,
  GenericSequenceType,
  HttpStatus,
} from "../../../common/Constants";
import service from "../service";
import { defaultTableChange } from "../../../../modules/custom/customTable";

class MasterHargaJasaDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      detail: {
        dataDetail: [],
        mainDealer: null,
        kodeCabang: null,
      },
      mdOptions: [],
      cabangOptions: [],
      kodeJasaOptions: [],
      namaJasaOptions: [],
      namaJasaFiltered: [],
      kodeJasaFiltered: [],
      uploadVisible: false,
      errors: {},
      tempIdDoc: null,
      pagination: {
          page: 1,
          limit: 5,
          totalData: 0,
      },
    };
  }

  componentDidMount() {
    this.loadInitialData();
  }

  fetchDetail = async (id, mdOptions) => {
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").getDetailMasterHargaJasa,
      menuName: "Master Harga Jasa",
      setError: this.props.setError,
      args: {
        servicePriceId: id,
      },
    });
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      const selectedMd = mdOptions?.find(
        (item) => item.value === res.data.data.mainDealer
      );
      this.setState((prev) => ({
        ...prev,
        detail: {
          ...prev.detail,
          ...service.constructgetDetailData(res.data.data, selectedMd),
        },
        pagination: {
            ...prev.pagination,
            totalData: res.data.data.length,
        }
      }));
    }
  };

  loadInitialData = async () => {
    this.props.handleLoading();
    const cabang = this.props.menuAccess.map((data) => data.idRefObj);
    const promises = [
      fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA")
          .getMainDealerForSalesOrderDGI,
        setError: this.props.setError,
        menuName: "Master Harga Jasa",
        args: {
          kodeCabang: cabang,
          status: ["ACTIVE"]
        },
      }),
      fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").masterServiceMainPage,
        menuName: "Master Harga Jasa",
        setError: this.props.setError,
        args: {},
      }),
    ];

    if (this.props.activityType === ACTIVITY_TYPE.CREATE) {
      promises.push(
        fetchDataAsync({
          asyncFn: Api.create("NAGAMAS_MASTER_DATA").getGenSeqWithoutSave,
          menuName: "Master Harga Jasa",
          setError: this.props.setError,
          args: {
            seqType: GenericSequenceType.MASTER_SERVICE_PRICE,
            nosDealerCode: this.props.selectedCabang?.value,
            transactionType: GenericSequenceType.MASTER_SERVICE_PRICE,
          },
        })
      );
    }

    const response = await Promise.all(promises);
    let listMd = [];
    if (response[0].ok && response[0].data.status === HttpStatus.SUCCESS) {
      const { data } = response[0].data;
      listMd = data.map((item) => {
        return {
          value: item.supplierCode,
          label: item.supplierName,
          kodeCabang: this.props.dataCabang?.filter((cb) =>
            item.kodeCabang.includes(cb?.value)
          ),
        };
      });
      if (listMd.length > 0) {
        this.setState((prevState) => ({
          ...prevState,
          mdOptions: listMd,
        }));
      }
    }

    if (response[1].ok && response[1].data.status === HttpStatus.SUCCESS) {
      const data = response[1].data.data;
      this.setState((prevValue) => ({
        ...prevValue,
        kodeJasaOptions: data.map((item) => service.getJasaDDL(item, "kode")),
        namaJasaOptions: data.map((item) => service.getJasaDDL(item, "nama")),
      }));
    }

    if (response[2] && response[2].ok && response[2].data) {
      this.setState((prev) => ({
        ...prev,
        tempIdDoc: response[2].data,
      }));
    }

    if (this.props.activityType === ACTIVITY_TYPE.UPDATE) {
      await this.fetchDetail(this.props.selectedId, listMd);
    }

    this.props.handleLoading();
  };

  handleAddData = () => {
    if(this.state.detail?.dataDetail?.find(item=>!item.isSaved)){
      return this.props.handleAlertInfo("Informasi", "Terdapat data harga jasa yang belum disimpan. Silakan simpan atau hapus data terlebih dahulu.");
    }
    this.setState((prev) => ({
      ...prev,
      detail: {
        ...prev.detail,
        dataDetail: [
          ...(prev.detail?.dataDetail || []),
          INITIAL_VALUE_TABLE_DETAIL,
        ],
      },
    }));
  };

  handleSelectValue = (name, value, index) => {
    if (name === "kodeJasa" || name === "namaJasa") {
      if (
        service.validateRowJasa(
          index,
          name,
          value,
          this.state.detail?.dataDetail
        )
      ) {
        return this.props.handleAlertInfo(
          "Informasi",
          "Jasa sudah ada dalam daftar. Silahkan pilih jasa lain."
        );
      }
    }
    this.setState((prev) => {
      const newData = [...prev.detail?.dataDetail];
      newData[index] = {
        ...newData[index],
        [name]: value,
      };
      return {
        ...prev,
        detail: {
          ...prev.detail,
          dataDetail: newData,
        },
      };
    });
  };

  handleDelete = (index) => {
    this.setState((prev) => {
      const errorsForTab = { ...(prev.errors || {}) };

      delete errorsForTab[index];

      const updatedErrors = Object.values(errorsForTab).reduce(
        (acc, err, idx) => {
          acc[idx] = err;
          return acc;
        },
        {}
      );

      const updatedDataDetail =
        prev.detail?.dataDetail?.filter((_, i) => i !== index) || [];

      return {
        ...prev,
        detail: {
          ...prev.detail,
          dataDetail: updatedDataDetail,
        },
        errors: updatedErrors,
      };
    });
  };

  toggleEdit = (index, confirmed) => {
    this.setState((prev) => {
      const newData = [...prev.detail?.dataDetail];
      newData[index] = {
        ...newData[index],
        isSaved: confirmed,
      };
      return {
        ...prev,
        detail: {
          ...prev.detail,
          dataDetail: newData,
        },
      };
    });
  };

  handleOpenKodeJasa = () => {
    console.log(this.state)
    this.setState((prev) => ({
      ...prev,
      kodeJasaFiltered: prev?.kodeJasaOptions?.filter(
        (item) =>
          !prev?.detail?.dataDetail
            ?.map((item) => item.kodeJasa)
            ?.includes(item.value)
      ),
    }));
  };

  handleOpenNamaJasa = () => {
    this.setState((prev) => ({
      ...prev,
      namaJasaFiltered: prev?.namaJasaOptions?.filter(
        (item) =>
          !prev?.detail?.dataDetail
            ?.map((item) => item.namaJasa?.value)
            ?.includes(item.value)
      ),
    }));
  };

  getTableConfig = () => {
    const { kodeJasaFiltered, namaJasaFiltered } = this.state;
    return tableConfigDetailPage({
      dataTable: this.state.detail?.dataDetail,
      handleDelete: this.handleDelete,
      toggleEdit: this.toggleEdit,
      handleSaveRow: this.handleSaveCorrection,
      handleSelectValue: this.handleSelectValue,
      kodeJasaOptions:
        kodeJasaFiltered.length > 0
          ? kodeJasaFiltered
          : this.state.kodeJasaOptions,
      namaJasaOptions:
        namaJasaFiltered.length > 0
          ? namaJasaFiltered
          : this.state.namaJasaOptions,
      errors: this.state.errors,
      onOpenKodeJasa: this.handleOpenKodeJasa,
      onOpenNamaJasa: this.handleOpenNamaJasa,
    });
  };

  handleSetData = (name, value) => {
    this.setState((prev) => ({
      ...prev,
      detail: {
        ...prev.detail,
        [name]: value,
      },
    }));
  };

  handleValidateSubmit = () => {
    const payload = service.constructPayloadSubmit({
      ...this.state.detail,
      selectedCabang: this.props.selectedCabang,
    });

    const { detailPrice, ...rest } = payload;
    const payloadValidation = {
      ...rest,
      detailPrice: this.state.detail?.dataDetail,
    };

    const { isValid, errors, invalidDetail } =
      service.validateHargaJasaData(payloadValidation);

    if (!isValid) {
      const { detailPrice, ...rest } = errors;
      this.setState((prev) => ({
        ...prev,
        errors: {
          ...prev.errors,
          ...rest,
        },
      }));
      const msg = invalidDetail
        ? "Terdapat data harga jasa yang belum disimpan. Silakan simpan atau hapus data terlebih dahulu."
        : "Terdapat data yang belum lengkap, mohon periksa kembali";

      this.props.handleAlertInfo("Informasi", msg);
      return;
    }
    this.handleSubmit(payload);
  };

  handleSubmit = (payload) => {
    this.props.handleAlertInfo(
      "Pertanyaan",
      "Apakah anda yakin ingin menyimpan data ini?",
      "submit",
      payload
    );
  };

  handleUploadVisibility = () => {
    const isInvalid = this.state.detail?.dataDetail?.find(
      (item) => !item.isSaved
    );
    if (isInvalid) {
      return this.props.handleAlertInfo(
        "Informasi",
        "Terdapat data harga jasa yang belum disimpan. Silakan simpan atau hapus data terlebih dahulu."
      );
    }
    this.setState((prevValue) => ({
      ...prevValue,
      uploadVisible: !prevValue.uploadVisible,
    }));
  };

  handleSuccessUpload = (data) => {
    if (service.validateUploadJasa(data, this.state.detail?.dataDetail)) {
      return this.props.handleAlertInfo(
        "Informasi",
        "Terdapat jasa yang sudah ada dalam daftar. Silahkan pilih jasa lain."
      );
    }
    this.handleUploadVisibility();
    this.setState((prev) => ({
      ...prev,
      detail: {
        ...prev.detail,
        dataDetail: [...(prev.detail?.dataDetail || {}), ...data],
      },
    }));
  };

  handleSaveCorrection = (index) => {
    const { dataDetail } = this.state.detail;
    const rowData = dataDetail[index];
    const validationResult = service.validateRow(rowData);
    const hasError = Object.values(validationResult).some((v) => v !== null);

    this.setState((prev) => {
      const updatedErrors = { ...prev.errors };

      if (hasError) {
        updatedErrors[index] = validationResult;
      } else {
        delete updatedErrors[index];
      }

      return {
        ...prev,
        errors: {
          ...prev.errors,
          ...updatedErrors,
        },
      };
    });

    if (!hasError) {
      this.toggleEdit(index, true);
    }
  };

  handleChangePage = (tableState) => {
      this.setState((prevValue) => ({
          ...prevValue,
          pagination:{
              ...prevValue.pagination,
              page: tableState.page + 1,
          }
      }));
  };
  handleRowsPerPage = (tableState) => {
      this.setState((prevValue) => ({
          ...prevValue,
          pagination:{
              ...prevValue.pagination,
              page: 1,
              limit: tableState.rowsPerPage,
          }
      }));
  };

  render() {
    const { visible, onClickClose } = this.props;
    const { mdOptions, detail, cabangOptions, errors, tempIdDoc, pagination } = this.state;
    return (
      <SimpleModal
        title="Detail Harga Jasa"
        visible={visible}
        styles={{ width: "85%" }}
        onClickClose={() => onClickClose()}
        content={
          <ModalContainer>
            <MasterHargaJasaDetailHeader
              detail={detail}
              cabangOptions={cabangOptions}
              dataMD={mdOptions}
              errors={errors}
              tempIdDoc={tempIdDoc}
              onSetData={this.handleSetData}
            />
            <SimpleButton
              id="btn_add_data"
              text="Tambah"
              styles={{ marginLeft: 0, marginBottom: "20px" }}
              icon={<i className="fa fa-plus margin margin-right-5px" />}
              onClick={this.handleAddData}
            />
            <SimpleDataTable
              key={`${pagination.totalData}-${pagination.page}`}
              data={this.state.detail?.dataDetail}
              columns={this.getTableConfig()}
              toCount={pagination.totalData}
              rowsPerPage={pagination.limit}
              page={pagination.page - 1}
              options={{...defaultTableChange(this.handleChangePage, this.handleRowsPerPage), serverSide: false}}
            />
            <FlexView hAlignContent="right" className="margin margin-top-20px">
              <SimpleButton
                text="Upload"
                onClick={this.handleUploadVisibility}
              />
              <SimpleButton text="Simpan" onClick={this.handleValidateSubmit} />
            </FlexView>
            {this.state.uploadVisible && (
              <MasterHargaJasaUpload
                {...this.props}
                visible={this.state.uploadVisible}
                onSuccessUpload={this.handleSuccessUpload}
                onClickClose={this.handleUploadVisibility}
                triggerLoading={this.props.handleLoading}
              />
            )}
          </ModalContainer>
        }
      />
    );
  }
}

export default MasterHargaJasaDetail;
